import { BaseEntityInfoUtils, EntityInfo } from '@record-it-npm/synchro-common';
import { AppCommonSynchronizationEnvironmentTypes } from '../../../AppCommonSynchronizationEnvironment';
import { EntityName } from '../../../EntityName';
import { CreateEntityInfoOptions } from '../../base/CreateEntityInfoOptions';
import { UserGroupDto } from './UserGroupDto';
export function createUserGroupEntityInfo<TEntity extends UserGroupDto>(options: CreateEntityInfoOptions<UserGroupDto, TEntity>): EntityInfo<AppCommonSynchronizationEnvironmentTypes, EntityName.UserGroup, TEntity> {
  return {
    entityName: EntityName.UserGroup,
    synchronizeRelativeTo: [],
    trackGlobalRevision: true,
    fieldInfos: BaseEntityInfoUtils.createFieldInfos<AppCommonSynchronizationEnvironmentTypes, UserGroupDto, TEntity>({
      ...BaseEntityInfoUtils.createBaseFieldInfos<AppCommonSynchronizationEnvironmentTypes>(),
      name: {
        name: 'name',
        defaultValue: ''
      }
    }, options.additionalFieldInfos)
  };
}